import React, { useState, useEffect } from "react";
import DashboardStatusCard from "../officerDashboard/dashboardStatusCard";
import axios from "axios";
import { AUTH_URL, CHAT_URL } from "../../utils/constants";
import { ThreeDotsLoader } from "../commonComponent/loader";
import bgOfficer from "../../assets/images/bg_officer.png";
import listIcon from "../../assets/images/list.png";
import Swal from "sweetalert2";
import DashboardStatesUser from "./DashboardUser";
import { useAuth } from "../../utils/AuthContext";
import AiSummaryModal from "../commonComponent/AiSummaryModal";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

const DashboardList = () => {
  const [data, setData] = useState([]);
  const [dashboardData, setDashboardData] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [showCommentArea, setShowCommentArea] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [comment, setComment] = useState(""); // New state to store comment
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [queryUpdate, setQueryUpdate] = useState(true);
  const { user } = useAuth();
  
  const [aiSummaryOpen, setAiSummaryOpen] = useState(false);
  const [aiSummaryText, setAiSummaryText] = useState("");
  const [aiSummaryLoading, setAiSummaryLoading] = useState(false);

  const handleAiSummary = async () => {
    if (!selectedRow) return;
    setAiSummaryOpen(true);
    setAiSummaryLoading(true);
    setAiSummaryText("");
    try {
      const res = await axios.post(
        `${CHAT_URL}v1/generate_ai_summary`,
        {
          grievance_id: selectedRow.grievance_id || selectedRow.id,
          role: "user",
        },
        { headers: { "Content-Type": "application/json" } }
      );
      setAiSummaryText(res.data.summary || "No summary available.");
    } catch (err) {
      setAiSummaryText("Could not generate summary. Please try again.");
    } finally {
      setAiSummaryLoading(false);
    }
  };


  const handleViewClick = (item) => {
    setSelectedRow(item);
    setIsViewOnly(true); // Set view-only mode
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
  };
  const handleLikeClick = (e) => {
    e.preventDefault();
    setIsLiked(true);
    setShowCommentArea(false); // Hide comment area after liking
  };

  const handleDislikeClick = (e) => {
    e.preventDefault();
    setIsLiked(false);
    setShowCommentArea(true); // Show comment area after disliking
  };

  const handleSave1 = async () => {
    setSaveLoading(true);
    try {
      const feedbackData = {
        grievance_id: selectedRow.id, // Assuming you have selectedRow.id for grievance ID
        feedbackrating: isLiked ? 1 : 0, // 1 for like, 0 for dislike
        feedbacktext: comment, // The comment entered by the user
      };

      const res = await axios(`${AUTH_URL}/api/feedback`, feedbackData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (res.status === 200) {
        console.log("Feedback saved successfully");
        // Optionally, reset the states after saving
        setIsLiked(false);
        setComment("");
        setShowCommentArea(false);
      }
    } catch (error) {
      console.error("Error saving feedback:", error);
    } finally {
      setSaveLoading(false);
    }
  };

  // useEffect(() => {
  //   console.log("all query dashboard : 75");
  //   const getUserQueriesCall = async () => {
  //     setLoading(true);
  //     try {
  //       let res = await axios.get(`${AUTH_URL}api/allquery?user_id=${user.userId}`, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       });
  //       if (res.data) {
  //         const apiPayload = Array.isArray(res.data?.data) ? res.data?.data : res.data?.data.queries || [];
  //         const reversedData = Array.isArray(apiPayload) ? [...apiPayload].reverse() : [];

  //         const normalizeStatus = (status) => {
  //           const s = (status || 'pending').toLowerCase();
  //           if (s === 'pending') return 'Pending';
  //           if (s === 'resolved' || s === 'closed') return 'Resolved';
  //           if (s === 'rejected') return 'Rejected';
  //           if (s === 'responded') return 'Responded';
  //           return 'Other';
  //         };

  //         const buildStatusSummary = (items) => {
  //           const summaryMap = {};
  //           items.forEach((item) => {
  //             const status = normalizeStatus(item.status);
  //             if (!summaryMap[status]) {
  //               summaryMap[status] = {
  //                 name: status,
  //                 count: 0,
  //                 percentage: item.percentage ?? 0,
  //               };
  //             }
  //             summaryMap[status].count += 1;
  //           });
  //           return Object.values(summaryMap);
  //         };

  //         const summary = Array.isArray(res.data?.data.summary)
  //           ? res.data?.data.summary
  //           : buildStatusSummary(reversedData);

  //         setData(reversedData);
  //         const resolved = reversedData?.filter(
  //           (item) => item.status === "Responded"
  //         );
  //         const total = reversedData?.length;
  //         setDashboardData({
  //           total: total,
  //           pending: reversedData?.length - resolved?.length,
  //           closed: resolved?.length,
  //           summary,
  //         });
  //         setQueryUpdate(false);
  //       }
  //     } catch (error) {
  //       console.log("there is some error", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   if (queryUpdate) {
  //     getUserQueriesCall();
  //   }
  // }, [queryUpdate]);

  useEffect(() => {
    const getUserQueriesCall = async () => {
      setLoading(true);
      try {
        if (!user?.userId) {
          console.warn("User not logged in or userId missing.");
          setLoading(false);
          return;
        }
        const res = await axios.get(`${AUTH_URL}api/allquery?user_id=${user.userId}`, {
          headers: { "Content-Type": "application/json" },
        });

        if (res.data && res.data.success) {
          const apiPayload = Array.isArray(res.data.data) ? res.data.data : [];
          // newest first
          const reversedData = [...apiPayload].reverse();

          const buildStatusSummary = (items) => {
            const summaryMap = {};
            items.forEach((item) => {
              const status = item.user_grievance_status || "Open";
              if (!summaryMap[status]) {
                summaryMap[status] = { name: status, count: 0 };
              }
              summaryMap[status].count += 1;
            });
            return Object.values(summaryMap);
          };

          const resolved = reversedData.filter(i => i.user_grievance_status === "Resolved");
          const pending  = reversedData.filter(i => i.user_grievance_status === "Open");
          const wip      = reversedData.filter(i => i.user_grievance_status === "InProgress");

          setData(reversedData);
          setDashboardData({
            total:   reversedData.length,
            pending: pending.length,
            resolved: resolved.length,
            wip:     wip.length,
            summary: buildStatusSummary(reversedData),
          });
        }
      } catch (error) {
        console.error("Error fetching user grievances:", error);
      } finally {
        setLoading(false);
        setQueryUpdate(false);
      }
    };

    if (queryUpdate) {
      getUserQueriesCall();
    }
  }, [queryUpdate, user?.userId]);

  const handleSave = async () => {
    try {
      setSaveLoading(true);
      let res = await axios.put(
        `${AUTH_URL}api/grievance_response`,
        {
          query_id: selectedRow._id,
          officer_grievance_comments: selectedRow.officer_grievance_comments,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status === 200) {
        setIsModalOpen(false);
        setQueryUpdate(true);
        Swal.fire({
          title: "Query Updated!",
          text: "You have successfully updated.",
          icon: "success",
        });
      }
    } catch (error) {
      console.log("Error in Update Query API", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error?.response?.data?.error}` || "Error in Update Query API",
      });
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${bgOfficer})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        // opacity: "46%",
      }}
      className="px-4 py-5 box-border w-full h-full  "
    >
      <DashboardStatesUser dashboardData={dashboardData} data={data} />
      {/* <DashboardStatusCard dashboardData={dashboardData} /> */}
      {/* <div className="h-[70%] z-45 bg-white  rounded-lg flex flex-col mt-5">
        <div className="px-4 py-2 flex items-center gap-x-2 bg-slate-400 rounded-t-lg">
          <img src={listIcon} alt="list_icon" />
          List of Queries Asked
        </div>
        {!loading && (
          <div className="p-2 overflow-auto">
            <table className="w-full border-collapse border border-gray-300">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    SN
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    User Query
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    Bot Response
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    User Id
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    Status
                  </th>
                  <th className="border border-gray-300 px-4 py-2 text-left">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <tr key={index + 1} className="hover:bg-gray-100">
                      <td className="border border-gray-300 px-4 py-2">
                        {index + 1}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.grievance_title || item.user_query}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.llm_response_desc
                          ?.split(" ")
                          .slice(0, 5)
                          .join(" ")}
                        ...
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.user_id}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        {item.status}
                      </td>
                      <td className="border border-gray-300 px-4 py-2">
                        <button
                          className={`px-3 py-1 text-white rounded  focus:ring focus:ring-blue-300 ${item.status === "Responded"
                              ? "bg-blue-500 hover:bg-blue-600"
                              : "bg-green-500 hover:bg-green-600"
                            }`}
                          onClick={() => handleViewClick(item)}
                        >
                          {item.status === "Responded" ? "Edit" : "View"}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="6"
                      className="border border-gray-300 px-4 py-2 text-center text-gray-500"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {isModalOpen && selectedRow && (
              <div className="fixed inset-0 flex items-start sm:items-center justify-center bg-black bg-opacity-50 z-50 p-4 sm:p-0">
                <div className="bg-white w-full sm:w-1/2 p-5 sm:p-6 rounded shadow-lg max-h-[85vh] sm:max-h-[85vh] overflow-auto mt-6 sm:mt-0">
                  <h3 className="text-lg font-bold mb-4">View Query</h3>
                  <form className="space-y-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        User Query
                      </label>
                      <input
                        type="text"
                        name="user_query"
                        value={selectedRow.user_query}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Bot Response
                      </label>
                      <textarea
                        type="text"
                        name="llm_response_desc"
                        value={selectedRow.llm_response_desc}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                        rows={3} // You can adjust the number of rows as per your requirement
                      ></textarea>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Comment from officer
                      </label>
                      <textarea
                        name="officer_grievance_comments"
                        value={
                          selectedRow?.officer_grievance_comments ||
                          selectedRow?.grievance_response
                        }
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-blue-300"
                        rows={3} // You can adjust the number of rows as per your requirement
                      ></textarea>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        User Id
                      </label>
                      <input
                        type="text"
                        name="user_id"
                        value={selectedRow.user_id}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Ministry
                      </label>
                      <input
                        type="text"
                        name="llm_ministry"
                        value={selectedRow.llm_ministry}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Category
                      </label>
                      <input
                        type="text"
                        name="llm_category"
                        value={selectedRow.llm_category}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Sub Category
                      </label>
                      <input
                        type="text"
                        name="llm_subcategory"
                        value={selectedRow.llm_subcategory}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        State
                      </label>
                      <input
                        type="text"
                        name="state"
                        value={selectedRow.state || ""}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        District
                      </label>
                      <input
                        type="text"
                        name="district"
                        value={selectedRow.district}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        City
                      </label>
                      <input
                        type="text"
                        name="city"
                        value={selectedRow.city}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Severity
                      </label>
                      <input
                        type="text"
                        name="severity"
                        value={selectedRow.severity}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        Status
                      </label>
                      <input
                        type="text"
                        name="status"
                        value={selectedRow.status}
                        readOnly={isViewOnly}
                        className="mt-1 w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700">
                        FeedBack
                      </label>
                    </div>
                    <div>
                      {selectedRow.status === "Responded" && (
                        <button
                          className={`w-20 px-4 py-2 text-white rounded mr-2 ${isLiked
                              ? "bg-blue-700 hover:bg-blue-800"
                              : "bg-blue-500 hover:bg-blue-600"
                            }`}
                          onClick={handleLikeClick}
                        >
                          {isLiked ? "Liked" : "Like"}
                        </button>
                      )}

                      {selectedRow.status === "Responded" && (
                        <button
                          className="w-20 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                          onClick={handleDislikeClick}
                        >
                          Dislike
                        </button>
                      )}

                      {showCommentArea && (
                        <div className="mt-4">
                          <textarea
                            placeholder="Please provide your comment..."
                            className="w-full p-2 border border-gray-300 rounded"
                            rows="4"
                            onChange={(e) => setComment(e.target.value)} // Save comment to state
                          />
                        </div>
                      )}
                    </div>

                    <div className="flex justify-end space-x-4 pt-4 border-t">
                      <button
                        type="button"
                        className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700 whitespace-nowrap flex items-center gap-1 text-sm mr-auto"
                        onClick={handleAiSummary}
                      >
                        <AutoAwesomeIcon fontSize="small" /> AI Summary
                      </button>
                      <button
                        type="button"
                        className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                        onClick={handleClose}
                      >
                        Close
                      </button>
                      {selectedRow.status === "Responded" && (
                        <button
                          type="button"
                          className="px-4 py-2 bg-[#45B07B] text-white rounded hover:bg-brand-teal"
                          onClick={handleSave1}
                        >
                          {saveLoading ? "Saving..." : "Save"}
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        )}
        {loading && (
          <div className="flex justify-center">
            <ThreeDotsLoader className="animate-pulse" />
          </div>
        )}
      </div> */}
      <AiSummaryModal
        isOpen={aiSummaryOpen}
        onClose={() => setAiSummaryOpen(false)}
        summaryText={aiSummaryText}
        loading={aiSummaryLoading}
        grievanceData={selectedRow}
        role="User"
      />
    </div>
  );
};

export default DashboardList;
